<template>
    <input
        v-if="
            filter.current_shortcut_key != 'staff_name' &&
            filter.current_shortcut_key != 'created_duration'
        "
        @keypress.enter="$parent.$parent.$parent.user_logs_filter()"
        v-model="filter.columns[filter.current_shortcut_key]"
        :placeholder="$t('ui.general.search__key', {
            key: $t('models.attributes.user_logs.'+filter.current_shortcut_key)
        })"
        type="text"
    >

    <!--
    * ========================================================================
    * = 自行定義
    * ========================================================================
    -->
    <input
        v-else-if="
            filter.current_shortcut_key == 'staff_name'
        "
        @keypress.enter="$parent.$parent.$parent.user_logs_filter()"
        v-model="filter.columns.staff_name"
        :placeholder="$t('ui.general.search__key', {
            key: $t('ui.pages.user_logs.operator')
        })"
        type="text"
    >
    <DatePicker
        v-else-if="filter.current_shortcut_key == 'created_duration'"
        v-model="filter.columns.created_duration"
        style="min-width: 200px;width:100%;"
        type="daterange"
        format="YYYY-MM-DD"
        key="user_logs_created_at">
    </DatePicker>
</template>

<script>
import DatePicker from "@toolbox/date_picker/main.vue"

export default {
    name: "UserLogsFilterHeaderInputs",
    data() {
        return {
            is_initialized: false,
        }
    },
    computed: {
        current_store() {
            return this.$store.state.provider.user_logs_module
        },
        filter() {
            return this.current_store.filter
        },
    },
    created() {
    },
    mounted() {
    },
    watch: {
    },
    methods: {
    },
    components: {
        DatePicker
    }
}
</script>
